/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Th1Inputs */

const en_mk_cmp_linear_th1 = /** @type {(inputs: Mk_Cmp_Linear_Th1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centred on product and engineering teams.`)
};

const id_mk_cmp_linear_th1 = /** @type {(inputs: Mk_Cmp_Linear_Th1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berpusat pada tim produk dan engineering.`)
};

/**
* | output |
* | --- |
* | "Centred on product and engineering teams." |
*
* @param {Mk_Cmp_Linear_Th1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_th1 = /** @type {((inputs?: Mk_Cmp_Linear_Th1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Th1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_th1(inputs)
	return en_mk_cmp_linear_th1(inputs)
});